import $ from 'jquery';
import dot from 'dot/doT';
import template from '../../views/filterblocks/activefilters.dot';
const templateFunction = dot.template(template);



export default class ActiveFilters {
    constructor(el,  options = {}) {
        if (!el) {
            return;
        }
        this.options = options;
        this.el = el;
        this.selectedItemsEl = el.find('ul.filters__selected__items');
        this.filters = options.initialFilters || [];
        if (options.initialFilters) {
            this.drawFilters();
        }
    }
    removeFilterByValue(value) {
        const filter = this.filters.find(filter => filter.value == value);
        this.filters = this.filters.filter(filter => filter.value != value);
        this.drawFilters();
        if (this.options.onFilterRemove && filter) {
            this.options.onFilterRemove([filter]);
        }

    }
    removeFilterByName(name) {
        const filter = this.filters.find(filter => filter.name == name);
        this.filters = this.filters.filter(filter => filter.name != name);
        this.drawFilters();
        if (this.options.onFilterRemove && filter) {
            this.options.onFilterRemove([filter]);
        }
    }
    addFilter(filterOptions, canHaveMultiple) {
        const { name, label, value, inputEl } = filterOptions;
        const filter = this.filters.find(filter => filter.name === name);
        if (filter === undefined) {
            this.filters.push(filterOptions);
        }
        else if(canHaveMultiple){ //and filter not null
            this.filters.push(filterOptions);
        }
        else {
            if (inputEl != filter.inputEl && this.options.onFilterRemove) {
                this.options.onFilterRemove([filter]);
            }
            filter.value = value;
            filter.label = label;
            filter.inputEl = inputEl;
        }
        this.drawFilters();
    }
    _clearAll() {
        if (this.options.onFilterRemove) {
            this.options.onFilterRemove(this.filters);
        }
        this.filters = [];
        this.drawFilters();
        if (this.options.onClearAll) {
            this.options.onClearAll();
        }
    }

    drawFilters() {
        this.el.html('');
        if (this.filters) {
            this.el.html(templateFunction({
                selectedFilters: this.filters
            }));
            this.el
                .find('li,.input__label')
                .click(this._fliterClickHandler.bind(this));
            this.el.find('.filters__clear').click(this._clearAll.bind(this));
        }
    }

    _fliterClickHandler(e)
    {
        const value = $(e.target).data('value');
        this.removeFilterByValue(value);
        this.drawFilters();
    }

}
